import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Grid } from '@material-ui/core';

import CollapsibleCard from 'core/components/collapsible-card';
import Section from 'core/components/section';
import withDatePicker from 'core/components/with-date-picker';
import FormList from 'core/components/form-list';
import { useCurrentState } from 'common/hooks/useCurrentState';
import { AddMortgage, MortgageItem } from '../../mortgage-details';
import { DwellingAddress } from '../../dwelling-address';
import { Property } from './property';
import { Residents } from './residents';
import useStyles from './detail.styles';

const Detail = ({ disabled }) => {
  const classes = useStyles();

  const { values, setFieldValue } = useFormikContext();
  const { condo } = values;

  const state = useCurrentState(values);

  useEffect(() => {
    if (condo.mortgageDetails.length > 0) {
      if (!condo.mortgageDetails.find((item) => item.primary)) {
        setFieldValue('condo.mortgageDetails.0', { ...condo.mortgageDetails[0], primary: true });
      }
    } else {
      setFieldValue('primaryMortgageDetail.mortgageHolderAddress', {
        city: '',
        state: '',
        zip: '',
        address: '',
        address2: ''
      });
      setFieldValue('primaryMortgageDetail.mortgageHolderName', '');
      setFieldValue('primaryMortgageDetail.mortgageHolderId', '');
      setFieldValue('primaryMortgageDetail.loanNumber', '');
    }
  }, [condo.mortgageDetails, condo.mortgageDetails.length, setFieldValue]);

  return (
    <Section title="Condo detail" type="SubSection">
      <CollapsibleCard
        initialOpen
        content={
          <DwellingAddress
            dwelling="Condo"
            fieldName="condo.condoLocation"
            location={condo.condoLocation}
            latitude={condo.latitude}
            longitude={condo.longitude}
            includeApt
          />
        }
      >
        <Grid container justify="space-around" className={classes.container}>
          <Grid container spacing={2} justify="space-around" alignItems="flex-start">
            <Residents state={state} />
            <Property />
          </Grid>
        </Grid>
        <Grid container className={classes.mortgages}>
          <FormList
            disabled={disabled}
            id="condo.mortgageDetails"
            item={MortgageItem}
            type="InnerSection"
            addForm={AddMortgage}
            title="Mortgage Details"
            singular="Mortgage"
            plural="Mortgages"
          />
        </Grid>
      </CollapsibleCard>
    </Section>
  );
};

Detail.propTypes = {
  disabled: PropTypes.bool
};

Detail.defaultProps = {
  disabled: false
};

export default withDatePicker(Detail);
